// Scripts librairies
import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')

docReady(function () {
  const target = document.querySelector('#go')
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' })
  }
})
